
import {map, distinctUntilChanged} from 'rxjs/operators';
import { User } from '../models';
import { Observable ,  ReplaySubject ,  BehaviorSubject } from 'rxjs';
import { JwtService } from './jwt.service';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTableParams } from 'angular-datatables-all-versions';
//angular-datatables-all-versions

@Injectable()
export class SeekerService {
  private currentUserSubject = new BehaviorSubject<User>(new User());
  public currentUser = this.currentUserSubject
    .asObservable().pipe(
    distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private jwtService: JwtService
  ) {}

  // Verify JWT in localstorage with server & load user's info.
  // This runs once on application startup.
  populate() {
    // If JWT detected, attempt to get & store user's info
    if (this.jwtService.getToken()) {
      this.apiService
        .get('/user')
        .subscribe(data => this.setAuth(data), err => this.purgeAuth());
    } else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
    }
  }

  setAuth(user: User) {
    // Save JWT sent from server in localstorage
    this.jwtService.saveToken(user.auth_token);
    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
  }

  purgeAuth() {
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    // Set current user to an empty object
    this.currentUserSubject.next(new User());
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
  }

  attemptAuth(credentials): Observable<User> {
    return this.apiService
      .post('/admin/auth', { credentials: credentials })
      .map(data => {
        this.setAuth(data);
        return data;
      });
  }

  list(): Observable<any> {
    return this.apiService.get('/gandadmin/users');
  }

  find(params: DataTableParams): Observable<any> {
    return this.apiService.post('/gandadmin/seeker/show', params);
  }

  list_paginated(params: DataTableParams): Observable<any> {
    params.offset = params.offset / params.limit;
    return this.apiService.post('/gandadmin/users', params);
  }

  enableOrDesableUser(user: User): Observable<User> {
    const verb = user.is_active ? 'deactivate' : 'activate';
    return this.apiService.post('/gandadmin/users/' + user.id + '/' + verb);
  }

  /**
   * Create user
   * @param type type account [facebook, manual]. If empty, creates default user
   * @param user user data
   */
  create(type, user): Observable<User> {
    const route = type === 'facebook' ? '/facebook' : '';
    return this.apiService.post('/signup' + route, { user: user }).map(data => {
      this.setAuth(data.user);
      return data.user;
    });
  }

  findById(id: number): Observable<User> {
    return this.apiService.get('/gandadmin/users/' + id);
  }

  findByIdAndFetchDetails(id: number): Observable<User> {
    return this.apiService.get('/gandadmin/users/details/' + id);
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

  update(user: User): Observable<User> {
    // let postData = {};
    // if (UserRoleEnum.COMPANY === user.role.id) {
    //   postData = Object.assign({}, {
    //     user: user,
    //     entreprise: Object.assign({}, {
    //       enterprise_name: user.entreprise.enterprise_name,
    //       enterprise_number: user.entreprise.enterprise_number,
    //       fix_phone: user.entreprise.fix_phone,
    //       mob_phone: user.entreprise.mob_phone,
    //       entreprise_address: Object.assign({}, {
    //         address_line_1: user.entreprise.entreprise_address.address_line_1,
    //         city: user.entreprise.entreprise_address.city,
    //         post_code: user.entreprise.entreprise_address.post_code,
    //         country_iso: user.entreprise.entreprise_address.country_iso
    //       })
    //     })
    //   })
    // } else {
    //   postData = { user: user }
    // }

    return this.apiService
      .put('/gandadmin/users/' + user.id, { user: user })
      .map(data => {
        // Update the currentUser observable
        // TODO if current user
        // this.currentUserSubject.next(data);
        return data;
      });
  }

  updatePassword(user: User): Observable<any> {
    return this.apiService.put('/gandadmin/users/' + user.id + '/password', {
      user: {
        password: user.password,
        password_confirmation: user.password_confirmation
      }
    });
  }
}
